import React from 'react';
import { Button, Modal, Typography } from 'antd';
import { Colors } from 'works/legacy/lib/style-helper';

const { Text } = Typography;

type Props = {
  visible: boolean;
  onContinue: () => void;
};

export function ComplianceLinkAssignmentsWarningModal({
  visible,
  onContinue,
}: Props) {
  return (
    <>
      <Modal
        title="This operation erases any existing compliance uploads"
        visible={visible}
        onCancel={onContinue}
        footer={[
          <Button key="confirm" type="primary" onClick={onContinue}>
            Continue
          </Button>,
        ]}
      >
        <Text style={{ color: Colors.midnightLighter }}>
          The compliance list on each relinked assignment will be refreshed as a
          clean list.
        </Text>
      </Modal>
    </>
  );
}
